import React from 'react';

const ErrorTimePage = () => {
  return (
    <div className="error-container">
      <h1>Limite de Envio Atingido</h1>
      <p>Você já enviou o formulário recentemente. Por favor, aguarde uma hora antes de tentar novamente.</p>
    </div>
  );
};

export default ErrorTimePage;
